import { Outlet } from 'react-router'

export const AiCallingAccessLayout = () => {
  return <Outlet />
}
